// extracted by mini-css-extract-plugin
module.exports = {"R3Page":"ProductContent_R3Page__UhTMN","cnPage":"ProductContent_cnPage__fw9QR"};